import {
  DivAlertInfo,
  DivAlertInfo2,
  DivAlertInfo3,
  DivAlertInfoContact,
  DivAlertInfoP,
  DivGeral,
  FooterContainer,
  SobreContainer,
} from "./styles";

import alertIcon from "../../assets/images/alert_icon.svg";
import telefoneIcon from "../../assets/images/telefone_icon.svg";
import whatsIcon from "../../assets/images/whats_icon.svg";
import logoSuprema from "../../assets/images/logo_suprema.webp";
import xicxic from "../../assets/images/xicxic.webp";

const Footer = () => {
  return (
    <>
      <SobreContainer>
        <DivGeral>
          <DivAlertInfo>
            <img src={alertIcon} alt="Alert Icon" />
            <DivAlertInfoP>
              Prezados clientes e parceiros, a Suprema Charque LTDA. informa que
              apenas se comunica através de seus canais e domínios eletrônicos
              oficiais, sendo os principais:
            </DivAlertInfoP>
          </DivAlertInfo>
          <DivAlertInfoContact>
            <DivAlertInfoP
              style={{
                fontWeight: "600",
                color: "#000",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                cursor: "pointer",
              }}
              onClick={() => {
                window.location.href = "https://wa.me/5587981717049";
              }}
            >
              <img
                src={whatsIcon}
                alt="WhatsApp Icon"
                style={{ width: "24px", height: "24px" }}
              />
              87 98171-7049
            </DivAlertInfoP>

            <DivAlertInfoP
              style={{
                fontWeight: "600",
                color: "#000",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
              onClick={() => {
                window.location.href =
                  "mailto:atendimento@supremacharque.com.br";
              }}
            >
              <img
                src={telefoneIcon}
                alt="Telefone Icon"
                style={{ width: "24px", height: "24px" }}
              />
              atendimento@supremacharque.com.br
            </DivAlertInfoP>
          </DivAlertInfoContact>
          <DivAlertInfoP>
            Qualquer tentativa de contato e/ou comunicação envolvendo algum
            domínio diferente pode ser considerada como indevida e/ou uma
            tentativa de fraude.
          </DivAlertInfoP>
        </DivGeral>
        <DivAlertInfo2
          style={{ width: "auto", display: "flex", flexDirection: "column" }}
        >
          <h2>INSTITUCIONAL</h2>

          <a
            href="/"
            style={{
              color: "#000",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Home
          </a>
          <a
            href="/history"
            style={{
              color: "#000",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Nossa história
          </a>
          <a
            href="/products"
            style={{
              color: "#000",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Produtos
          </a>
          <a
            href="/revenues"
            style={{
              color: "#000",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Receitas
          </a>
          <a
            href="/contact-us"
            style={{
              color: "#000",
              textDecoration: "none",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Fale Conosco
          </a>
          <a
            href="/privacy-policies"
            style={{
              color: "#000",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Política de Privacidade
          </a>
        </DivAlertInfo2>
        <DivAlertInfo3
          style={{ width: "auto", display: "flex", flexDirection: "column" }}
        >
          <img
            src={logoSuprema}
            alt="Logo Suprema Charque"
            width={250}
            height={200}
            style={{ objectFit: "contain", width: "100%", height: "auto" }}
          />
          <h2 style={{ textAlign: "center" }}>SUPREMA CHARQUE LTDA</h2>
          <p>CNPJ: 48.186.898/0001-60</p>
        </DivAlertInfo3>
      </SobreContainer>

      <div style={{ width: "100%" }}>
        <FooterContainer>
          <p>Suprema Charque ® Todos os direitos reservados</p>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "20px",
              alignItems: "center",
            }}
          >
            <p>Desenvolvido por</p>
            <img
              src={xicxic}
              alt="Xic Xic"
              style={{ width: "50px", cursor: "pointer" }}
              onClick={() => {
                window.location.href =
                  "https://www.instagram.com/xicxiccomunica?igsh=MWdlbzUwYWZzNnY1ZQ==";
              }}
            />
          </div>
        </FooterContainer>
      </div>
    </>
  );
};

export default Footer;
